import { useQuery } from '@tanstack/react-query';
import { catalogService } from '@/services/catalogService';
import { queryKeys } from '@/lib/queryKeys';

export function useCatalogMaintenanceEligible(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.catalog.maintenanceEligible(),
    queryFn: () => catalogService.listMaintenanceEligibleCatalogIds(),
    staleTime: 30_000,
    enabled: options?.enabled ?? true,
  });
}
